import React, { useState } from "react";
import { Modal, Tabs, Tab, Form, Button, Alert, Row, Col, Accordion } from "react-bootstrap";
import "../CSS/ClientMenuModal.css";

const ClientMenuModal = ({
  showMenu, setShowMenu, selectedMenuUser, setSelectedMenuUser, selectedStep, setSelectedStep,
  handleFormAssignment, handleMemberFormAssignment, handleStepSubmit, handleMemberStepSubmit,
  isStepSubmitted, isMemberStepSubmitted, canSubmitStep, canSubmitMemberStep,
  toggleServiceLock, handleMemberNameUpdate, addMember, removeMember,
  handleUSAFormationStepSubmit, isUSAFormationStepSubmitted, canSubmitUSAFormationStep,
  handleCompanyFormAssignment, handleTaxDateUpdate, handleMemberTaxDateUpdate
}) => {
  const [activeTab, setActiveTab] = useState("primary");
  const [newMemberName, setNewMemberName] = useState("");
  const [activeMemberAccordion, setActiveMemberAccordion] = useState(null);
  const [selectedMemberService, setSelectedMemberService] = useState("tax");
  const [primaryTaxYearEndDate, setPrimaryTaxYearEndDate] = useState("");
  const [memberTaxYearEndDates, setMemberTaxYearEndDates] = useState({});

  const handleTabSelect = (tab) => {
    setActiveTab(tab);
    setActiveMemberAccordion(null);
  };

  const toggleMemberAccordion = (index) => {
    setActiveMemberAccordion(activeMemberAccordion === index ? null : index);
  };

  const handleAddMemberWithService = async () => {
    try {
      const memberIndex = await addMember(selectedMenuUser._id);
      if (newMemberName) {
        await handleMemberNameUpdate(selectedMenuUser._id, memberIndex, newMemberName);
        setNewMemberName("");
      }
    } catch (error) {
      console.error("Error adding member:", error);
    }
  };

  // Helper function to format date for display
  const formatDateForDisplay = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  // Helper function to format date for input field
  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
  };

  // Helper function to get due date period text
  const getDueDatePeriod = (formType) => {
    if (formType === '1040' || formType === '1120') {
      return '3.5 months';
    } else if (formType === '1065' || formType === '1120-S') {
      return '2.5 months';
    }
    return '';
  };

  return (
    <Modal show={showMenu} onHide={() => setShowMenu(false)} size="xl">
      <Modal.Header closeButton className="border-0 pb-0 custom-modal-header">
        <Modal.Title className="fw-bold title">Client Management</Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-3">
        <Tabs activeKey={activeTab} onSelect={handleTabSelect} className="mb-3">
          <Tab eventKey="services" title="Services">
            <h5 className="fw-bold mb-3">Service Lock/Unlock</h5>
            <div className="service-toggle-container p-3 rounded">
              {[
                { id: "usa-company-switch", label: "USA Company Formation", key: "isUSAEnabled" },
                { id: "tax-filing-switch", label: "Tax Filing", key: "isTaxFilingEnabled" },
                { id: "bookkeeping-switch", label: "Bookkeeping", key: "isBookkeepingEnabled" },
                { id: "cfo-switch", label: "CFO Advisory", key: "isCFOEnabled" },
                { id: "registered-agent-switch", label: "Registered Agent", key: "isRegisteredAgentEnabled" },
                { id: "annual-report-switch", label: "Annual Report Service", key: "isAnnualReportServiceEnabled" }
              ].map(service => (
                <div key={service.id} className="service-toggle-item d-flex justify-content-between align-items-center py-2">
                  <span className="fw-medium">{service.label}</span>
                  <Form.Check
                    type="switch"
                    id={service.id}
                    checked={selectedMenuUser?.[service.key] || false}
                    onChange={(e) => toggleServiceLock(
                      selectedMenuUser._id,
                      service.label,
                      e.target.checked
                    )}
                  />
                </div>
              ))}
            </div>
          </Tab>

          <Tab eventKey="primary" title="Primary Member">
            <h5 className="fw-bold mb-3">Assign Form</h5>
            <div className="d-flex gap-2 mb-4">
              <Form.Select
                className="flex-grow-1"
                value={selectedMenuUser?.assignedForm || "1040"}
                onChange={(e) =>
                  setSelectedMenuUser({
                    ...selectedMenuUser,
                    assignedForm: e.target.value
                  })
                }
              >
                <option value="1040">1040</option>
                <option value="1065">1065</option>
                <option value="1120-S">1120-S</option>
                <option value="1120">1120</option>

              </Form.Select>
              <Button
                variant="primary"
                onClick={() =>
                  handleFormAssignment(selectedMenuUser._id, selectedMenuUser.assignedForm)
                }
              >
                Assign
              </Button>
            </div>

            <h5 className="fw-bold mb-3 mt-4">Tax Year End Date & Due Date</h5>
            <div className="mb-4">
              <Form.Group className="mb-3">
                <Form.Label>Tax Year End Date</Form.Label>
                <div className="d-flex gap-2">
                  <Form.Control
                    type="date"
                    value={primaryTaxYearEndDate || formatDateForInput(selectedMenuUser?.taxYearEndDate)}
                    onChange={(e) => setPrimaryTaxYearEndDate(e.target.value)}
                  />
                  <Button
                    variant="success"
                    onClick={() => {
                      const dateToUpdate = primaryTaxYearEndDate || formatDateForInput(selectedMenuUser?.taxYearEndDate);
                      if (dateToUpdate) {
                        handleTaxDateUpdate(selectedMenuUser._id, dateToUpdate);
                        setPrimaryTaxYearEndDate("");
                      }
                    }}
                    disabled={!primaryTaxYearEndDate && !selectedMenuUser?.taxYearEndDate}
                  >
                    Update
                  </Button>
                </div>
              </Form.Group>
              
              {selectedMenuUser?.taxYearEndDate && selectedMenuUser?.dueDate && (
                <Alert variant="info" className="mb-0">
                  <strong>Current Tax Year End:</strong> {formatDateForDisplay(selectedMenuUser.taxYearEndDate)}
                  <br />
                  <strong>Due Date:</strong> {formatDateForDisplay(selectedMenuUser.dueDate)}
                  {getDueDatePeriod(selectedMenuUser.assignedForm) && (
                    <span className="text-primary"> ({getDueDatePeriod(selectedMenuUser.assignedForm)})</span>
                  )}
                </Alert>
              )}
            </div>

            <h5 className="fw-bold mb-3">Submit Primary Steps</h5>
            <Form.Select
              value={selectedStep}
              onChange={(e) => setSelectedStep(parseInt(e.target.value))}
              className="mb-2"
            >
              {[2, 3, 4].map(step => {
                const isSubmitted = isStepSubmitted(selectedMenuUser, step);
                const canSubmit = canSubmitStep(selectedMenuUser, step);
                return (
                  <option key={`primary-${step}`} value={step} disabled={isSubmitted || !canSubmit}>
                    Step {step}
                    {isSubmitted && " ✓"}
                    {!isSubmitted && !canSubmit && " (Locked)"}
                  </option>
                );
              })}
            </Form.Select>
            <Button
              variant="warning"
              className="w-100"
              onClick={handleStepSubmit}
              disabled={
                isStepSubmitted(selectedMenuUser, selectedStep) ||
                !canSubmitStep(selectedMenuUser, selectedStep)
              }
            >
              {isStepSubmitted(selectedMenuUser, selectedStep)
                ? "Already Submitted"
                : "Submit Step"}
            </Button>
            {isStepSubmitted(selectedMenuUser, selectedStep) && (
              <Alert variant="info" className="mt-2 py-2">This step has already been submitted.</Alert>
            )}
            {!canSubmitStep(selectedMenuUser, selectedStep) && !isStepSubmitted(selectedMenuUser, selectedStep) && (
              <Alert variant="warning" className="mt-2 py-2">Complete previous steps first.</Alert>
            )}
          </Tab>

          <Tab eventKey="usa-formation" title="USA Company Formation">
            <h5 className="fw-bold mb-3">Company Formation Assignment</h5>
            <div className="d-flex gap-2 mb-4">
              <Form.Select
                className="flex-grow-1"
                value={selectedMenuUser?.assignedCompanyForm || "LLC"}
                onChange={(e) =>
                  setSelectedMenuUser({
                    ...selectedMenuUser,
                    assignedCompanyForm: e.target.value
                  })
                }
              >
                <option value="LLC">LLC</option>
                <option value="C-Corp">C-Corp</option>
              </Form.Select>
              <Button
                variant="primary"
                onClick={() =>
                  handleCompanyFormAssignment(selectedMenuUser._id, selectedMenuUser.assignedCompanyForm)
                }
              >
                Assign
              </Button>
            </div>

            <h5 className="fw-bold mb-3">Submit USA Formation Steps</h5>
            <Form.Select
              value={selectedStep}
              onChange={(e) => setSelectedStep(parseInt(e.target.value))}
              className="mb-2"
            >
              {[2, 3].map(step => {
                const isSubmitted = isUSAFormationStepSubmitted(selectedMenuUser?._id, step);
                const canSubmit = canSubmitUSAFormationStep(selectedMenuUser?._id, step);
                return (
                  <option key={`usa-${step}`} value={step} disabled={isSubmitted || !canSubmit}>
                    Step {step}
                    {isSubmitted && " ✓"}
                    {!isSubmitted && !canSubmit && " (Locked)"}
                  </option>
                );
              })}
            </Form.Select>
            <Button
              variant="warning"
              className="w-100"
              onClick={() => handleUSAFormationStepSubmit(selectedStep)}
              disabled={
                isUSAFormationStepSubmitted(selectedMenuUser?._id, selectedStep) ||
                !canSubmitUSAFormationStep(selectedMenuUser?._id, selectedStep)
              }
            >
              {isUSAFormationStepSubmitted(selectedMenuUser?._id, selectedStep)
                ? "Already Submitted"
                : "Submit Step"}
            </Button>
            {isUSAFormationStepSubmitted(selectedMenuUser?._id, selectedStep) && (
              <Alert variant="info" className="mt-2 py-2">This step has already been submitted.</Alert>
            )}
            {!canSubmitUSAFormationStep(selectedMenuUser?._id, selectedStep) && !isUSAFormationStepSubmitted(selectedMenuUser?._id, selectedStep) && (
              <Alert variant="warning" className="mt-2 py-2">Complete previous steps first.</Alert>
            )}
          </Tab>

          <Tab eventKey="members" title="New Members">
            <Row>
              <Col md={6} className="border-end pe-4">
                <h5 className="fw-bold mb-3">Add New Member</h5>
                <Form.Select
                  value={selectedMemberService}
                  onChange={(e) => setSelectedMemberService(e.target.value)}
                  className="mb-3"
                >
                  <option value="usa">USA Company Formation</option>
                  <option value="tax">Tax Filing</option>
                  <option value="bookkeeping">Bookkeeping</option>
                  <option value="cfo">CFO Advisory</option>
                </Form.Select>
                <div className="d-flex mb-3">
                  <Form.Control
                    type="text"
                    placeholder="New Member Name"
                    className="me-2"
                    value={newMemberName}
                    onChange={(e) => setNewMemberName(e.target.value)}
                  />
                  <Button
                    variant="success"
                    onClick={handleAddMemberWithService}
                    disabled={selectedMenuUser?.members?.length >= 50}
                  >
                    Add
                  </Button>
                </div>
                <div className="member-list">
                  {selectedMenuUser?.members?.map((member, index) => (
                    <div key={index} className="member-control mb-2 p-2 border rounded">
                      <Row>
                        <Col xs={8}>
                          <Form.Control
                            type="text"
                            value={member.name || ""}
                            placeholder={`Member ${index + 1} Name`}
                            onChange={(e) => {
                              const updated = [...selectedMenuUser.members];
                              updated[index].name = e.target.value;
                              setSelectedMenuUser({ ...selectedMenuUser, members: updated });
                            }}
                          />
                        </Col>
                        <Col xs={4} className="d-flex justify-content-end">
                          <Button
                            size="sm"
                            className="me-2"
                            variant="primary"
                            onClick={() => {
                              handleMemberNameUpdate(selectedMenuUser._id, index, member.name);
                              toggleMemberAccordion(index);
                            }}
                          >
                            Update
                          </Button>
                          <Button
                            size="sm"
                            variant="danger"
                            onClick={() => removeMember(selectedMenuUser._id, index)}
                          >
                            Remove
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </div>
              </Col>

              <Col md={6}>
                <div className="member-details">
                  <Accordion activeKey={activeMemberAccordion}>
                    {selectedMenuUser?.members?.map((member, index) => (
                      <Accordion.Item eventKey={index} key={index}>
                        <Accordion.Header onClick={() => toggleMemberAccordion(index)}>
                          Member {index + 1}: {member.name || "Unnamed"}
                        </Accordion.Header>
                        <Accordion.Body>
                          <h6 className="fw-bold mb-2">Assign Member Form</h6>
                          <div className="d-flex mb-3">
                            <Form.Select
                              value={member.assignedForm || "1040"}
                              className="flex-grow-1 me-2"
                              onChange={(e) => {
                                const form = e.target.value;
                                const updated = [...selectedMenuUser.members];
                                updated[index].assignedForm = form;
                                setSelectedMenuUser({ ...selectedMenuUser, members: updated });
                              }}
                            >
                              <option value="1040">1040</option>
                              <option value="1065">1065</option>
                              <option value="1120-S">1120-S</option>
                              <option value="1120">1120</option>

                            </Form.Select>
                            <Button
                              variant="primary"
                              onClick={() => handleMemberFormAssignment(
                                selectedMenuUser._id,
                                index,
                                member.assignedForm
                              )}
                            >
                              Assign
                            </Button>
                          </div>

                          <h6 className="fw-bold mb-2 mt-3">Tax Year End Date & Due Date</h6>
                          <div className="mb-3">
                            <Form.Group className="mb-2">
                              <Form.Label className="small">Tax Year End Date</Form.Label>
                              <div className="d-flex gap-2">
                                <Form.Control
                                  type="date"
                                  size="sm"
                                  value={memberTaxYearEndDates[index] || formatDateForInput(member?.taxYearEndDate)}
                                  onChange={(e) => setMemberTaxYearEndDates({
                                    ...memberTaxYearEndDates,
                                    [index]: e.target.value
                                  })}
                                />
                                <Button
                                  size="sm"
                                  variant="success"
                                  onClick={() => {
                                    const dateToUpdate = memberTaxYearEndDates[index] || formatDateForInput(member?.taxYearEndDate);
                                    if (dateToUpdate) {
                                      handleMemberTaxDateUpdate(selectedMenuUser._id, index, dateToUpdate);
                                      setMemberTaxYearEndDates({
                                        ...memberTaxYearEndDates,
                                        [index]: ""
                                      });
                                    }
                                  }}
                                  disabled={!memberTaxYearEndDates[index] && !member?.taxYearEndDate}
                                >
                                  Update
                                </Button>
                              </div>
                            </Form.Group>
                            
                            {member?.taxYearEndDate && member?.dueDate && (
                              <Alert variant="info" className="mb-0 py-2 small">
                                <strong>Tax Year End:</strong> {formatDateForDisplay(member.taxYearEndDate)}
                                <br />
                                <strong>Due Date:</strong> {formatDateForDisplay(member.dueDate)}
                                {getDueDatePeriod(member.assignedForm) && (
                                  <span className="text-primary"> ({getDueDatePeriod(member.assignedForm)})</span>
                                )}
                              </Alert>
                            )}
                          </div>

                          <h6 className="fw-bold mb-2">Submit Member Steps</h6>
                          <Form.Select
                            className="mb-2"
                            value={selectedStep}
                            onChange={(e) => setSelectedStep(parseInt(e.target.value))}
                          >
                            {[2, 3, 4].map(step => {
                              const isSubmitted = isMemberStepSubmitted(selectedMenuUser, index, step);
                              const canSubmit = canSubmitMemberStep(selectedMenuUser, index, step);
                              return (
                                <option key={step} value={step} disabled={isSubmitted || !canSubmit}>
                                  Step {step} {isSubmitted && "✓"} {!isSubmitted && !canSubmit && "(Locked)"}
                                </option>
                              );
                            })}
                          </Form.Select>
                          <Button
                            variant="warning"
                            className="w-100"
                            onClick={() => handleMemberStepSubmit(index)}
                            disabled={isMemberStepSubmitted(selectedMenuUser, index, selectedStep) ||
                              !canSubmitMemberStep(selectedMenuUser, index, selectedStep)}
                          >
                            {isMemberStepSubmitted(selectedMenuUser, index, selectedStep)
                              ? "Already Submitted"
                              : "Submit Step"}
                          </Button>

                          {isMemberStepSubmitted(selectedMenuUser, index, selectedStep) && (
                            <Alert variant="info" className="mt-2 py-2">Step already submitted.</Alert>
                          )}
                          {!canSubmitMemberStep(selectedMenuUser, index, selectedStep) &&
                            !isMemberStepSubmitted(selectedMenuUser, index, selectedStep) && (
                              <Alert variant="warning" className="mt-2 py-2">Complete previous steps first.</Alert>
                            )}
                        </Accordion.Body>
                      </Accordion.Item>
                    ))}
                  </Accordion>
                </div>
              </Col>
            </Row>
          </Tab>
        </Tabs>
      </Modal.Body>
    </Modal>
  );
};

export default ClientMenuModal;
